module.exports = __webpack_public_path__ + "img/youngman.aa9ce9ba.png";